import { searchMatches } from '../../core';
import { Speaker } from '../speaker';

export const speakerMatches = (query: string) =>
  (mom: Speaker) => searchMatches([
    mom.name || '',
    mom.description].join(' '), query);